import l10n from '../l10n/localization';

export default {
    name: {
        presence: {
            message: l10n.validation.required,
        },
    },
    email: {
        email: {
            message: "invalid email address"
        },
    }
}
;



// WEBPACK FOOTER //
// ./src/validation/clientContact.js